import React, { Component } from "react";
import Image from '../global/Image';
import Cinemagraph from '../global/Cinemagraph';

export default class ProjectMedia extends Component {
  	
	render() {
		
		const row = this.props.row;
		
		let rowClass = 'c-project__media c-page__block--load-effect';
		if (this.props.first === true) {
			rowClass = 'c-project__media c-project__media--first c-page__block--load-effect';
		}
		
		if (row) {
							
			return (
								
				<div className={rowClass}>
					
					{row.type == 'image' &&
						<Image width={row.width} height={row.height} srcset={row.srcset} src={row.src} />
					}
					
					{row.type == 'cinemagraph' &&
						<Cinemagraph  width={row.width} height={row.height} src={row.src} />
					}
					
					{row.type == 'text' &&
						<div className="scope-project-text scope-project-text--dark" dangerouslySetInnerHTML={{__html:row.text}}></div>
					}
					
				</div>
					
			)
					
		} else {
			
			return null;
			
		}
		
	}
							
}